export default "__VITE_ASSET__BHBI0Tz$__"